<template>
  <div class="content-430">
    <div class="class-form-head">梯度设置</div>
    <div class="class-form-content">
      <div class="course-tab">
        <div v-for="(item,index) in courseTypeList" :key="index" class="tab-item" :class="item.disabled?'tab-item-none': item.value===courseTypeActive?'tab-item-active':''" @click="handleSwitchTab(item)">{{ item.name }}</div>
      </div>
      <div class="tab-content">
        <Form
          ref="gradSetInfo"
          :model="gradSetInfo"
          label-position="right"
          :label-width="150"
          :rules="gradSetInfoRule"
          @on-validate="getFormValidate"
        >
          <FormItem
            label="课酬计算方式"
            prop="calType"
          >
            <div class="caltype-line">
              <div class="line-item" :class="isSet?'line-item-none':''" @click="handleClickRadio('1')">
                <div class="icon-box">
                  <Icon v-show="+gradSetInfo.calType===1" :color="isSet?'#999':'#6149f1'" type="md-radio-button-on" size="18"></Icon>
                  <Icon v-show="+gradSetInfo.calType!==1" type="md-radio-button-off" size="18"></Icon>
                </div>
                <span>每节课X元</span>
              </div>
              <div class="line-item" :class="isSet?'line-item-none':''" @click="handleClickRadio('2')">
                <div class="icon-box">
                  <Icon v-show="+gradSetInfo.calType===2" :color="isSet?'#999':'#6149f1'" type="md-radio-button-on" size="18"></Icon>
                  <Icon v-show="+gradSetInfo.calType!==2" type="md-radio-button-off" size="18"></Icon>
                </div>
                <span>每个学生X元</span>
              </div>
            </div>
          </FormItem>
          <FormItem
            label="课酬梯度"
            prop="salarySet"
          >
            <div v-for="(item,index) in salaryGradSetInfo" :key="index" class="grad-item">
              <div v-if="index!==salaryGradSetInfo.length-1" class="item-line">
                {{ item.stuMin }}-<Input
                  v-if="!isSet"
                  v-model="item.stuMax"
                  class="num-input"
                  placeholder="请输入"
                  @on-blur="getNowStuMax(index)"
                ></Input><span v-else class="input-text">{{ item.stuMax }}</span>人，教师薪酬：<Input
                  v-if="!isSet"
                  v-model="item.onceFee"
                  class="num-input"
                  placeholder="请输入"
                  @on-blur="getNowFee(index)"
                ></Input><span v-else class="input-text">{{ item.onceFee }}</span>{{ gradSetInfo.calType | calTypeStr }} <div class="btn-box"><Icon v-if="showAddIcon(index)" color="#6149f1" size="24" type="md-add-circle" @click="handleAdd"></Icon><Icon v-if="showRemoveBtn(index)" color="red" size="24" type="md-remove-circle" @click="handleRemove(index)"></Icon></div>
              </div>
              <div v-else class="item-line">
                {{ item.stuMin }}人或以上，教师薪酬：<Input
                  v-if="!isSet"
                  v-model="item.onceFee"
                  class="num-input"
                  placeholder="请输入"
                  @on-blur="getNowFee(index)"
                ></Input><span v-else class="input-text">{{ item.onceFee }}</span>{{ gradSetInfo.calType | calTypeStr }}
              </div>
              <div class="err-line">
                <span>{{ item.errMax }}</span>
                <span>{{ item.errFee }}</span>
              </div>
            </div>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
export default {
  filters: {
    calTypeStr(calType) {
      if (+calType === 2) {
        return '元/学生';
      } else {
        return '元/节课';
      }
    }
  },
  inject: ['SalarySettingEditInstance'],
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      }
    }, // v-model的值
    isSet: {
      type: Boolean,
      default: false
    } // 设置适用学校
  },
  data() {
    return {
      gradSetInfo: {
        calType: '', // 计算方式 1：每节课X元 2：每个学生X元
        salarySet: '' // 课酬梯度设置
      },
      gradSetInfoRule: {
        // calType: [
        //   { required: true, message: '请选择课酬计算方式', trigger: 'change' }
        // ]
      },
      courseTypeList: [
        {
          name: '午托',
          value: '2',
          disabled: false
        }, {
          name: '晚托',
          value: '3',
          disabled: false
        }, {
          name: '晚自修',
          value: '4',
          disabled: false
        }, {
          name: '素质课程',
          value: '1',
          disabled: false
        }, {
          name: '早托',
          value: '5',
          disabled: true
        }
      ], // 课程类型 1：素质课 2：午托 3：晚托 4：晚自修 5：早托
      courseTypeActive: '2',
      salaryGradSetInfo: [
        {
          stuMin: 0, // 最小人数
          stuMax: '', // 最大人数
          errMax: '',
          onceFee: '', // 每节课酬 or  每人课酬
          errFee: ''
        }, {
          stuMin: 1, // 最小人数
          stuMax: 99999, // 最大人数
          errMax: '',
          onceFee: '', // 每节课酬 or  每人课酬
          errFee: ''
        }
      ]
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['theUserIdentity']),
    salarySetInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }
  },
  mounted() {
    this.SalarySettingEditInstance.gradSetNameObj.formTag = false;
  },
  methods: {
    // 自定义单选
    handleClickRadio(radio) {
      if (this.isSet) {
        return;
      }
      if (this.gradSetInfo.calType && this.gradSetInfo.calType === radio) {
        this.gradSetInfo.calType = '';
        return;
      }
      this.gradSetInfo.calType = radio;
    },
    // 编辑等进来的回填数据
    fillSetting(courseTypeActive) {
      this.courseTypeActive = courseTypeActive + '';
      this.gradSetInfo.calType = this.salarySetInfo[+courseTypeActive].calType;
      this.salaryGradSetInfo = this.salarySetInfo[+courseTypeActive].list;
      if (this.isSet) {
        this.courseTypeList = this.courseTypeList.map(item => {
          item.disabled = !this.salarySetInfo[+item.value];
          return item;
        });
      }
    },
    // 提交的时候做的校验
    getFormValidate() {
      this.SalarySettingEditInstance.gradSetNameObj.formTag = false;
      const tag = this.handleSwitchTab({ value: this.courseTypeActive });
      if (!tag) {
        return;
      }
      if (JSON.stringify(this.salarySetInfo) === '{}') {
        return this.$Message.error('至少需要设置一个课程类型的梯度!');
      }
      this.SalarySettingEditInstance.gradSetNameObj.formTag = true;
    },
    // 校验当前tab的内容是否填写完整(1:完全填写完整 2:没有填写完整 3:完全没有填写)
    checkNowTabIsFill() {
      const firstObj = this.salaryGradSetInfo[0];
      const secondObj = this.salaryGradSetInfo[1];
      let infoTag = false;
      if (firstObj.stuMin === 0 && firstObj.stuMax === '' && firstObj.onceFee === '' &&
         secondObj.stuMax === 99999 && secondObj.onceFee === '' &&
        this.salaryGradSetInfo.length === 2) {
        infoTag = true;
      }
      if (infoTag && this.gradSetInfo.calType === '') {
        return 3;
      }
      if (infoTag && this.gradSetInfo.calType !== '') {
        this.$Message.error('请先将空格输入完整！');
        return 2;
      }
      const tag = this.salaryGradSetInfo.every(item => {
        return item.stuMax !== '' && item.onceFee !== '';
      });
      if (!tag) {
        this.$Message.error('请先将空格输入完整！');
        return 2;
      }
      if (this.gradSetInfo.calType === '') {
        this.$Message.error('请选择课酬计算方式！');
        return 2;
      }
      return 1;
    },
    // 点击切换tab
    handleSwitchTab(item) {
      const { value, disabled, ...other } = item;
      if (disabled) {
        return false;
      }
      const fillTag = this.checkNowTabIsFill();
      const origin = [{
        stuMin: 0, // 最小人数
        stuMax: '', // 最大人数
        errMax: '',
        onceFee: '', // 每节课酬 or  每人课酬
        errFee: ''
      }, {
        stuMin: 1, // 最小人数
        stuMax: 99999, // 最大人数
        errMax: '',
        onceFee: '', // 每节课酬 or  每人课酬
        errFee: ''
      }];
      // 获取剔除了当前项的
      const otherTabObj = {};
      Object.keys(this.salarySetInfo).forEach(item => {
        if (item !== this.courseTypeActive) {
          otherTabObj[item] = this.salarySetInfo[item];
        }
      });
      if (fillTag === 2) {
        return false;
      }
      if (fillTag === 3) {
        // 当前项变为空，删除当前项
        this.salarySetInfo = otherTabObj;
      }
      if (fillTag === 1) {
        this.salarySetInfo[+this.courseTypeActive] = {
          list: this.salaryGradSetInfo,
          calType: this.gradSetInfo.calType
        };
      }
      this.gradSetInfo.calType = this.salarySetInfo[+value] ? this.salarySetInfo[+value].calType : '';
      const nextTabInfo = this.salarySetInfo[+value] ? this.salarySetInfo[+value].list : '';
      this.salaryGradSetInfo = nextTabInfo || origin;
      this.courseTypeActive = value;
      return true;
    },
    handleChangeCalType(e) {
      if (this.salarySetInfo[+this.courseTypeActive]) {
        this.salarySetInfo[+this.courseTypeActive].calType = e;
      } else {
        this.salarySetInfo[+this.courseTypeActive] = {};
        this.salarySetInfo[+this.courseTypeActive].calType = e;
      }
    },
    // 是否展示添加按钮
    showAddIcon(index) {
      if (this.isSet) {
        return false;
      }
      const listLength = this.salaryGradSetInfo.length;
      if (this.salaryGradSetInfo[index].stuMax === '') {
        return false;
      }
      if (index === 0 && listLength === 2) {
        return true;
      }
      if (index === listLength - 2) {
        return true;
      }
      return false;
    },
    // 是否展示移除按钮
    showRemoveBtn(index) {
      if (this.isSet) {
        return false;
      }
      const listLength = this.salaryGradSetInfo.length;
      if (index === 0) {
        return false;
      }
      if (index === 0 && listLength === 2) {
        return false;
      }
      if (index === listLength - 1) {
        return false;
      }
      return true;
    },
    // 点击添加按钮
    handleAdd() {
      const listLength = this.salaryGradSetInfo.length;
      const stuMax = this.salaryGradSetInfo[listLength - 1].stuMin;
      this.salaryGradSetInfo.splice(listLength - 1, 0, {
        stuMin: stuMax, // 最小人数
        stuMax: '', // 最大人数
        errMax: '',
        onceFee: '', // 每节课酬 or  每人课酬
        errFee: ''
      });
    },
    // 点击移除按钮
    handleRemove(index) {
      this.salaryGradSetInfo.splice(index, 1);
      this.salaryGradSetInfo.reduce((pre, cur, currentIndex) => {
        console.log(currentIndex, '当前索引是=====');
        cur.stuMin = currentIndex === 0 ? 0 : (+pre) + 1;
        return cur.stuMax;
      }, 0);
    },
    // 校验是最多两位小数的，大于等于0且小于等于1000
    checkIsTwoDigitNum(num) {
      if (isNaN(num)) {
        return '请输入正确数字';
      }
      if (+num <= 0) {
        return '请输入大于0的数';
      }
      if (+num > 1000) {
        return '请输入小于等于1000的数';
      }
      if (Number.isInteger(+num)) {
        return true;
      } else {
        const arr = num.split('.');
        let str = '';
        str = arr[1].length > 2 ? '请输入最多小数点后两位的数' : '';
        return str || true;
      }
    },
    // 校验是正整数
    checkIsPositiveInt(num) {
      if (isNaN(num)) {
        return '请输入正整数';
      }
      if (+num <= 0) {
        return '请输入正整数';
      }
      if (!Number.isInteger(+num)) {
        return '请输入正整数';
      }
      if (+num > 9999) {
        return '最大值为9999';
      }
      return true;
    },
    getNowFee(index) {
      const inputValue = this.salaryGradSetInfo[index].onceFee;
      const inputObj = this.salaryGradSetInfo[index];
      if (inputValue === '') {
        inputObj.errFee = '不能为空';
        this.salaryGradSetInfo.splice(index, 1, inputObj);
        return;
      }
      // 校验输入值必须为正整数
      const numResult = this.checkIsTwoDigitNum(inputValue);
      if (numResult !== true) {
        inputObj.onceFee = '';
        inputObj.errFee = numResult;
        this.salaryGradSetInfo.splice(index, 1, inputObj);
        return;
      }
      inputObj.errFee = '';
      this.salaryGradSetInfo.splice(index, 1, inputObj);
    },
    // 获取当前输入值
    getNowStuMax(index) {
      const inputValue = this.salaryGradSetInfo[index].stuMax;
      const itemMin = +this.salaryGradSetInfo[index].stuMin;
      const nextMax = +this.salaryGradSetInfo[index + 1].stuMax;
      const inputObj = this.salaryGradSetInfo[index];
      // 校验输入值不能为空
      if (inputValue === '') {
        inputObj.errMax = '不能为空';
        this.salaryGradSetInfo.splice(index, 1, inputObj);
        return;
      }
      // 校验输入值必须为正整数
      const numResult = this.checkIsPositiveInt(inputValue);
      if (numResult !== true) {
        inputObj.stuMax = '';
        inputObj.errMax = numResult;
        this.salaryGradSetInfo.splice(index, 1, inputObj);
        return;
      }
      // 校验输入值的大小
      if (itemMin > inputValue) {
        inputObj.stuMax = '';
        inputObj.errMax = '不能小于前一个值';
        this.salaryGradSetInfo.splice(index, 1, inputObj);
        return;
      }
      if (nextMax !== 0 && nextMax < inputValue) {
        inputObj.stuMax = '';
        inputObj.errMax = '不能大于下一个值的最大值';
        this.salaryGradSetInfo.splice(index, 1, inputObj);
        return;
      }
      inputObj.errMax = '';
      this.salaryGradSetInfo.splice(index, 1, inputObj);
      // 将下一个项的最小值改变
      console.log(index, this.salaryGradSetInfo.length - 2);
      const nextObj = this.salaryGradSetInfo[index + 1];
      nextObj.stuMin = (+inputValue) + 1;
      console.log('改变---', nextObj, '===========');
      this.salaryGradSetInfo.splice(index + 1, 1, nextObj);
      // if (index === this.salaryGradSetInfo.length - 2) {
      //   const nextObj = this.salaryGradSetInfo[index + 1];
      //   nextObj.stuMin = (+inputValue) + 1;
      //   console.log('改变---', nextObj, '===========');
      //   this.salaryGradSetInfo.splice(index + 1, 1, nextObj);
      // }
    }
  }

};
</script>
<style lang="scss" scoped>
.course-tab{
  border-radius: 4px;
  border: 1px solid #ccc;
  display: inline-block;
  margin-left: 150px;
  margin-bottom: 24px;
  overflow: hidden;
  .tab-item{
    padding: 12px 0;
    width: 120px;
    display: inline-block;
    text-align: center;
    cursor: pointer;
  }
  .tab-item-active{
    background: #6149f1;
    color: #fff;
  }
  .tab-item-none{
    cursor: not-allowed;
    background: #dcdee2;
    opacity: 0.5;
  }
  .tab-item+.tab-item{
    border-left:1px solid #ccc ;
  }
}
.grad-item{
  // margin-bottom: 16px;
}
.caltype-line{
  display: flex;
  align-items: center;
  .line-item{
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .icon-box{
    margin-right: 4px;
  }
  .line-item+.line-item{
    margin-left: 16px;
  }
  .line-item-none{
    cursor: not-allowed;
    opacity: 0.8;
  }
}
.input-text{
  display: inline-block;
  width: 100px;
  text-align: center;
  font-weight: bold;
}
.num-input{
  width: 100px;
  margin: 0 8px;
}
.btn-box{
  display: inline-block;
  margin-left: 16px;
}
.err-line{
  min-height: 0;
  span{
    font-size: 12px;
    color: red;
    margin-left: 20px;
  }
  span+span{
    margin-left: 180px;
  }
}
</style>
